<div class="col gap-16 w100" i18n>
  <div class="row space-between w100 align-center">
    <h2>Add Entry to Feedback Card</h2>
    <rr-icon name="close" (click)="close()" color="nutral"></rr-icon>
  </div>
  <div class="col gap-8 w100">
    <div class="mentor row align-center gap-8">
      <span class="">Coach: </span
      ><span class="strong">{{ agent?.name }}</span>
      |
      <span class="">Tag: </span
      ><span class="strong">{{ agent?.mainTag }}</span>
    </div>
    <rr-input label="Topic" [(ngModel)]="topic"></rr-input>
    <rr-textarea label="Content" [(ngModel)]="content"></rr-textarea>
  </div>
</div>
<div class="row justify-end w100">
  <rr-btn
    type="Primary"
    size="Medium"
    [disabled]="topic == '' || content == ''"
    (click)="adddEntry()"
    >{{ edited === true ? "Save Entry" : "Add Entry" }}</rr-btn
  >
</div>
